import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overviewProjectTypeClass'
})
export class OverviewProjectTypeClassPipe implements PipeTransform {
  transform(
    type: string,
    status: string,
    withPlacement: boolean,
    typeMostRecentlyExecuted: string,
    subProjectTypeRightMargin: boolean,
    alternative = 'subproject'
  ): string {
    const printType =
      typeMostRecentlyExecuted == null ? type : typeMostRecentlyExecuted;
    const rightMargin = subProjectTypeRightMargin ? ' smaller-right-space' : '';
    switch (printType) {
      case 'Adjustment':
        return `aanpassing${rightMargin}`;
      case 'SoldRented':
        return `verkocht-verhuurd${rightMargin}`;
      case 'Repo':
        return `weghalen${rightMargin}`;
      case 'BaseProject':
        return status === 'Uitgevoerd'
          ? `uitgevoerd${rightMargin}`
          : `${this.getNewLabel(withPlacement)}${rightMargin}`;
      default:
        return alternative + rightMargin;
    }
  }

  getNewLabel(withPlacement: boolean): string {
    if (withPlacement === true) {
      return 'plaatsing';
    }
    if (withPlacement === false) {
      return 'afhaling';
    }
    return 'nieuw';
  }
}
